import React from 'react';
import Configurator from "../Configurator/Configurator";

const Home = () => {

	return (
		<div key="home" className="home">
			<Configurator/>
		</div>
	);
};

export default Home;
